export default {
  width: "100%",
  height: "100%",
  objectFit: "cover"
};